module.exports = __webpack_public_path__ + "static/media/AgentEmail.7c5a9f67.svg";